import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";


export function adminShowAllAssignmentTransports(cursorTransportId) {
    let data = {};
    if (cursorTransportId !== "") {
        data = {
            cursor_transport_id: cursorTransportId,
        };
    }
    log(data);
    log("service name: " + config.adminShowAllAvailableTransportsForBundled)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminShowAllAvailableTransportsForBundled);
    return allTransports(data);
}


export function adminCreateBundledTransports(transportsIds) {
    let data = { transports_id: transportsIds }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminCreateBundledTransports);
    return allTransports(data);
}
export function adminArrangementBundledTransports(transports) {
    let data = { transports: transports }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminArrangementBundledTransports);
    return allTransports(data);
}
export function adminUnlockTransportForCreateBundled(transports) {
    let data = { transports_id: transports }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminUnlockTransportForCreateBundled);
    return allTransports(data);
}
export function adminUnlockTransportForArrangmentBundled(bundledId, transports) {
    let data = { bundled_id: bundledId, transports_id: transports }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminUnlockTransportForArrangmentBundled);
    return allTransports(data);
}